export default __webpack_public_path__ + "static/media/ShoppingCart.5abdd092.svg";